export function handleErrors(response: Response): Response {
  if (!response.ok) {
    const error: Error & { response?: Response } = new Error(response.statusText);
    error.response = response;
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
  }
  return response;
}
